import React from 'react';
// template components
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// Icons
import CoffeeCupDisposable from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/illustrative/lightTheme/CoffeeCupDisposable';
import PadlockDisengaged from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/illustrative/lightTheme/PadlockDisengaged';
import PersonOutwardArrows from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/illustrative/lightTheme/PersonOutwardArrows';
// native components
import UnderstandingProductGrouping from '../../../../components/understandingProductGrouping/understandingProductGrouping';

export const ITEMS = [
  {
    id: 'term-life-insurance-what-is-it',
    icon: CoffeeCupDisposable,
    title: (<>It&#39;s affordable</>),
    contentAs: 'div',
    content: (
      <Typography
        align='left'
        disableBottomPadding>
        For less than &#36;1 a day,<sup>1</sup> you can have the right amount of term life coverage you&#39;ll need to make sure your loved ones are taken care of financially if you pass away.
      </Typography>
    ),
  },
  {
    id: 'term-life-insurance-why-do-i-need-it',
    icon: PadlockDisengaged,
    title: (<>It&#39;s yours</>),
    contentAs: 'div',
    content: (
      <Typography
        align='left'
        disableBottomPadding>
        Having a policy with us means you&#39;re not tied to a workplace plan. You&#39;ll get the right amount you need &#40;typically not enough through work&#41; and it will be with you wherever your career takes you.
      </Typography>
    ),
  },
  {
    id: 'term-life-insurance-is-it-affordable',
    icon: PersonOutwardArrows,
    title: (<>It&#39;s flexible</>),
    contentAs: 'div',
    content: (
      <Typography
        align='left'
        disableBottomPadding>
        As life changes your term life policy can, too. You can convert some or all of it to a whole life policy that gives you lifelong coverage and builds cash value you can use for anything.
      </Typography>
    ),
  },
];

export default () => {
  return (
    <UnderstandingProductGrouping
      id='term-life-insurance'
      backgroundVariant='lightB'
      headingText={<>Term life coverage that fits <WidowBlock>your life.</WidowBlock></>}
      cardDataArray={ITEMS}
    />
  );
};
